import React from "react";
import styles from "./Loader.module.css";

const Loader = () => (
  <div className={styles.loaderStyles}>
    <div />
    <div />
  </div>
);

export default Loader;
